import { render, staticRenderFns } from "./TextoLongo.vue?vue&type=template&id=f10393d0"
import script from "./TextoLongo.vue?vue&type=script&lang=ts"
export * from "./TextoLongo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports